import { render, staticRenderFns } from "./add4G.vue?vue&type=template&id=db8784c0&scoped=true"
import script from "./add4G.vue?vue&type=script&lang=js"
export * from "./add4G.vue?vue&type=script&lang=js"
import style0 from "./add4G.vue?vue&type=style&index=0&id=db8784c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8784c0",
  null
  
)

export default component.exports